import { useQuery } from '@apollo/client';
import { useMemo } from 'react'
import { MODEL_INFOS } from 'src/graphql/queries/model';
import { modelInfoPeriodsIndex, modelInfosQuery, modelInfoType, periodModelReturnPeriodType, periodModelReturnType } from 'src/types/model-types';

const modelPeriods:Array<periodModelReturnPeriodType> = ['1M','3M','6M','1Y','3Y','5Y','10Y']

interface minstarttAtType {
  [x:string] : Date
}

const useModelInfos = () => {
  const query = useQuery<modelInfosQuery>(MODEL_INFOS);

  const parsed = useMemo(()=>{
    if (query.data?.modelInfos?.__typename === "ModelInfos") {
      let result:Array<modelInfoType> = []
      let target:Array<modelInfoType> = []
      let minStartAt:minstarttAtType = {}
      let modelInfos = query.data.modelInfos.models.slice()

      //periodIndexing ... 
      modelInfos.forEach((modelInfo)=>{
        let mdif = Object.assign({},modelInfo)
        const periodIndex:modelInfoPeriodsIndex = {}
        mdif.periodsModelReturn.forEach((pdr,i) => {
          periodIndex[pdr.period] = i
        })
        mdif.periodsIndex = periodIndex
        result.push(mdif)
      })

      //filter wrong start period ...
      modelPeriods.forEach((modelPeriod)=>{
        let minStartPeriodAt = new Date()

        //minStartPeriodAt ...
        result.forEach((model)=>{
          let pidx = model.periodsIndex?.[modelPeriod]
          if (pidx !== null && pidx !== undefined) {
            let startPeriodAtStr = model.periodsModelReturn[pidx].snapDatetime
            if (startPeriodAtStr) {
              let startPeriodAt = new Date(startPeriodAtStr)
              startPeriodAt.setUTCHours(0,0,0,0)
              if (startPeriodAt < minStartPeriodAt) minStartPeriodAt = startPeriodAt
            }
            }
          })

          minStartAt = {
            ...minStartAt,
            [modelPeriod] : minStartPeriodAt
          }
      })

      //remove return if start is less than max ...
      result.forEach((model)=>{
        let currentPeriodsModelReturn = model.periodsModelReturn.slice()

        modelPeriods.forEach((modelPeriod) => {
          let pidx = model.periodsIndex?.[modelPeriod]
          let currentPeriodModelReturn:periodModelReturnType 
          let minStartPeriodAt = minStartAt[modelPeriod]

          if (pidx !== null && pidx !== undefined) {

            let currentPeriodReturn = model.periodsModelReturn[pidx]
            let startPeriodAtStr = currentPeriodReturn.snapDatetime
            let startPeriodAt = new Date(startPeriodAtStr)
            startPeriodAt.setUTCHours(0,0,0,0)

            //startAt after minStartAt so this case cant compare
            if (startPeriodAt.getTime() > minStartPeriodAt.getTime()) {
              currentPeriodModelReturn = {
                period : currentPeriodReturn.period,
                return : null,
                snapDatetime : currentPeriodReturn.snapDatetime
              }
            } else {
              currentPeriodModelReturn = {
                period : currentPeriodReturn.period,
                return : currentPeriodReturn.return,
                snapDatetime : currentPeriodReturn.snapDatetime
              }
            }

            currentPeriodsModelReturn.splice(pidx,1,currentPeriodModelReturn)
          }
        })
        let mdif:modelInfoType = {
          ...model,
          periodsModelReturn : currentPeriodsModelReturn
        }
        target.push(mdif)
      })

      return target
    } 
    return []
  },[query.data])

  return {
    ...query,
    modelInfos : parsed
  }
}

export default useModelInfos